//# sourceMappingURL=my-month-labels.interface.js.map


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/mydatepicker/dist/interfaces/my-month-labels.interface.js
// module id = ../../../../mydatepicker/dist/interfaces/my-month-labels.interface.js
// module chunks = 4